import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class InterceptorService {
    constructor(){}

    isAuthenticatedUrl(url: string): boolean{
        // TODO: exclude more URLs if needed
        const isAuthenticatedUrl = 
            url.indexOf('/verify/') === -1
            && url.indexOf('/send-password-reminder') === -1
            && url.indexOf('/register') === -1
            && url.indexOf('/login') === -1
            && url.indexOf('/change-password') === -1
            && url.indexOf('/forgotten-password') === -1
            && url.indexOf('/translation/languages') === -1
        ;
        return isAuthenticatedUrl;
    }

    // noSuccessSnackbar(url: string): boolean{
    //     // TODO: include more URLs if needed
    //     const noSuccessSnackbar = 
    //         url.indexOf('/event-admin/event/grid-position/') > -1
    //         ;
    //     return noSuccessSnackbar;
    // }

    noErrorSnackbar(request: HttpRequest<any>, err: HttpErrorResponse): boolean{
        // TODO: include more URLs if needed
        const noErrorSnackbar = 
            request.url.endsWith('/upload')
            || request.url.endsWith('/upload-for-checking')
            || request.url.endsWith('/totp/verify')
            || request.url.endsWith('/change-own-password')
            || request.url.endsWith('/set-password')
            || (request.url.endsWith('/client') && request.method === 'POST' && [500, 409].includes(err.status))
        ;
        return noErrorSnackbar;
    }

    no401TotpError(request: HttpRequest<any>, err: HttpErrorResponse): boolean{
        // TODO: include more URLs if needed
        const no401Error = 
            (request.url.endsWith('/totp/verify') && request.method === 'POST' && err.status === 401)
        ;
        return no401Error;
    }

    no401Error(request: HttpRequest<any>, err: HttpErrorResponse): boolean{
        // TODO: include more URLs if needed
        const no401Error = 
            (request.url.endsWith('/set-password') && request.method === 'POST' && err.status === 401)
            || (request.url.endsWith('/client') && request.method === 'POST' && err.status === 401)
        ;
        return no401Error;
    }

    no403Error(request: HttpRequest<any>, err: HttpErrorResponse): boolean{
        // TODO: include more URLs if needed
        const no403Error = 
            request.url.indexOf('/admin/regulatory/document') > -1 && request.method === 'POST' && err.status === 403
        ;
        return no403Error;
    }
}
